import React from 'react';
import Flex from '../../containers/Flex';
import Spacer from '../../Spacer';
import Tickbox from '../../Tickbox';

const checkboxText = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500
};
const ColumnOption = ({ text, field, showInList, onChange }) => {
    return (
        <Flex
            centreVertical
            style={{ paddingBottom: 13 }}
            onClick={() => onChange(field)}
        >
            <Spacer width={13} />
            <Tickbox value={showInList} />
            <Spacer width={10} />
            <div style={checkboxText}>{text}</div>
        </Flex>
    );
};

export default ColumnOption;
